/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import { CircularProgress, Paper, Typography, IconButton, Menu, MenuItem, 
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@material-ui/core';
import { MoreVert, ArrowRightAlt } from '@material-ui/icons'

import GlobalFieldIcon from './GlobalFieldIcon'

import Action from '../../../../../fluid/Actions/ActionFactory'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})


class GlobalField extends Component {
    state = {
        anchorEl : null,
        rename_open : false,
        new_name : "",
        renaming : false,
        renaming_error : null,
        delete_open : false,
        deleting : false,
        delete_error : null
    }

    componentDidMount () {
        console.log("IRC :: Global Concept Data :", this.props.global_field_data)
    }

    isFocussed = () => {
        if (this.props.field_in_focus === null) {
            return false
        } else {
            if (this.props.field_in_focus.field === this.props.field_data.field) {
                return true
            } else {
                return false
            }
        }
    }

    isMapping = () => {
        if (this.props.mapping_global_field === null) {
            return false
        } else {
            if (this.props.mapping_global_field.global_field === this.props.global_field_data.global_field) {
                return true
            } else {
                return false
            }
        }
    }

    getMappedEntity = () => {
        console.log("IFC :: Mapped : ", this.props.global_field_data.mapped_entity)
        console.log("IFC :: Mapped type Of: ", typeof this.props.global_field_data.mapped_entity)

        if (typeof this.props.global_field_data.mapped_entity === 'object') {
            if (this.props.global_field_data.mapped_entity.group_id === 'singletons') {
                return ["singleton", this.props.global_field_data.mapped_entity.field]
            } else {
                return ["group", this.props.global_field_data.mapped_entity.group_name]
            }
        } else if (typeof this.props.global_field_data.mapped_entity === 'string') {
            return ["singleton", this.props.global_field_data.mapped_entity]
        }
    }

    renderMappedElement = () => {
        if (this.props.global_field_data.mapped_entity) {
            if (this.getMappedEntity()[0] === 'group') {
                return (
                    <Typography 
                        style = {{fontSize : 10, fontWeight : 600}} 
                        variant = 'caption' 
                        color = "primary" 
                    >{"Group: " + this.getMappedEntity()[1]}</Typography>
                )
            } else {
                return (
                    <Typography 
                        style = {{fontSize : 10, fontWeight : 600}} 
                        variant = 'caption' 
                        color = "primary" 
                    >{"Singleton: " + this.getMappedEntity()[1]}</Typography>
                )
            }
        } else {
            return (
                <Typography 
                    style = {{fontSize : 10}} 
                    variant = 'caption' 
                    color = "textSecondary" 
                ><em>Unmapped</em></Typography>
            )
        }
    }

    renderScore = () => {
        if (this.props.show_score) {
            if (this.props.global_field_data.score) {
                return (
                    <Typography style = {{ 
                        border: 'none',
                        fontSize : 13,
                        fontWeight : 900,
                        color : '#03AD93',
                        marginLeft: '10px',
                        marginRight : '10px'
                    }}>{this.props.global_field_data.score.toFixed(2)}</Typography>
                )
            }
        }
    }

    renderOptions = () => {
        if (this.props.show_options) {
            return (
                <IconButton 
                    style = {{padding : 0, marginLeft : "10px", marginRight : '10px'}} 
                    size = 'small' 
                    onClick = {(event) => {
                        event.stopPropagation();
                        event.nativeEvent.stopImmediatePropagation();
                        this.handleMenu(event)
                    }}
                >
                    <MoreVert style = {{color : '#707070'}} fontSize = 'small'/>
                </IconButton>
            )
        }
    }

    handleMenuClose = () => {
        this.setState({...this.state, anchorEl : null})
    }

    handleMenu = (event) => {
        if (this.state.anchorEl) {
            this.setState({...this.state, anchorEl : null})
        } else {
            this.setState({...this.state, anchorEl : event.currentTarget})
        }
    }

    renderMenu = () => {
        return (
            <Menu
                id="field_menu"
                anchorEl={this.state.anchorEl}
                keepMounted
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleMenuClose}
            >
                <MenuItem
                    onClick = {() => {
                        this.setState({...this.state, rename_open : true}, () => {
                            this.handleMenuClose()
                        })
                    }}
                >Rename</MenuItem>
                <MenuItem
                    disabled = {this.props.group_in_focus !== null ? false : true}
                    onClick = {() => {
                        let entity_id = this.props.group_in_focus.group_id
                        this.props.map_global_field(entity_id, this.props.global_field_data)
                    }}
                >Map to Current Group</MenuItem>
                <MenuItem
                    onClick = {() => {
                        this.setState({...this.state, delete_open : true}, () => {
                            this.handleMenuClose()
                        })
                    }}
                >Delete</MenuItem>
            </Menu>
        )
    }

    renderRenameDialog = () => {
        return (
            <Dialog open = {this.state.rename_open} onClose = {() => this.setState({...this.state, rename_open : false, new_name : ""})}>
                <DialogTitle>{"Rename " + this.props.global_field_display_name + " Field"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>Renaming the field will recompute the similarities. This action cannot be reversed. Please add the new name below.</DialogContentText>
                    {this.state.renaming_error && <Typography variant = 'caption' color = 'secondary'>Error renaming the field...</Typography>}
                    <div style = {{
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                    }}>
                        <div style = {{
                            width: '30%',
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            justifyContent : 'center'
                        }}>
                            <GlobalFieldIcon global_field_display_name = {this.props.global_field_display_name}/>
                            <Typography style = {{marginLeft : '5px'}} variant = 'subtitle2'>{this.props.global_field_data.global_field}</Typography>
                        </div>
                        <div style = {{
                            width: '30%',
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            justifyContent : 'center'
                        }}>
                            <ArrowRightAlt color = 'primary'/>
                        </div>
                        <div style = {{
                            width: '30%',
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            justifyContent : 'center'
                        }}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="new_name"
                                label="New Name"
                                fullWidth
                                value = {this.state.new_name}
                                helperText = {this.state.new_name === this.props.global_field_data.global_field ? "The new name is the same as the old name." : "Enter new name here."}
                                onChange = {(event) => this.setState({...this.state, new_name : event.target.value})}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        color = 'primary'
                        disabled = {this.state.new_name === "" || this.state.new_name === this.props.global_field_data.global_field}
                        onClick = {this.renameGlobalField}
                        startIcon = {this.state.renaming && <CircularProgress size = {20} color = 'primary'/>}
                    >Rename</Button>
                    <Button
                        color = 'secondary'
                        onClick = {() => this.setState({...this.state, rename_open : false, new_name : "", renaming : false, renaming_error : null})}
                    >Cancel</Button>
                </DialogActions>
            </Dialog>
        )
    }

    renameGlobalField = () => {
        this.setState({...this.state, renaming : true, renaming_error : null}, () => {
            Action('http_request', {
                url : "/sainapse/ifc/change_global_field_name",
                method: "post",
                data : {
                    global_field_name: this.props.global_field_data.global_field,
                    new_name : this.state.new_name,
                    ic_name : this.props.ic_name,
                    version: this.props.version
                }
            }).then(res => {
                this.setState({...this.state, rename_open : false, new_name : "", renaming : false, renaming_error : null}, () => this.props.refresh_report_and_data())
            }).catch(err => {
                this.setState({...this.state, renaming : false, renaming_error : err})
            })
        })
    }

    renderDeleteDialog = () => {
        return (
            <Dialog open = {this.state.delete_open} onClose = {() => this.setState({...this.state, delete_open : false})}>
                <DialogTitle>{"Delete " + this.props.global_field_display_name + " Field"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>Deleting the field will recompute the similarities. This action cannot be reversed.</DialogContentText>
                    {this.state.delete_error && <Typography variant = 'caption' color = 'secondary'>Error deleting the field...</Typography>}
                    <div style = {{
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        justifyContent : 'center'
                    }}>
                        <div style = {{
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            justifyContent : 'center'
                        }}>
                            <GlobalFieldIcon global_field_display_name = {this.props.global_field_display_name}/>
                            <Typography style = {{marginLeft : '5px'}} variant = 'subtitle2'>{this.props.global_field_data.global_field}</Typography>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        color = 'secondary'
                        onClick = {this.deleteGlobalField}
                        startIcon = {this.state.deleting && <CircularProgress size = {20} color = 'secondary'/>}
                    >Delete</Button>
                    <Button
                        color = 'primary'
                        onClick = {() => this.setState({...this.state, delete_open : false, deleting : false, delete_error : null})}
                    >Cancel</Button>
                </DialogActions>
            </Dialog>
        )
    }

    deleteGlobalField = () => {
        this.setState({...this.state, deleting : true, delete_error : null}, () => {
            Action('http_request', {
                url : "/sainapse/ifc/remove_global_field",
                method: "post",
                data : {
                    global_field_name: this.props.global_field_data.global_field,
                    ic_name : this.props.ic_name,
                    version: this.props.version
                }
            }).then(res => {
                this.setState({...this.state, delete_open : false, deleting : false, delete_error : null}, () => this.props.refresh_report_and_data())
            }).catch(err => {
                this.setState({...this.state, deleting : false, delete_error : err})
            })
        })
    }
    
    render () {
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper
                    style = {{
                        ...this.props.style,
                        width : '100%',
                        height : '60px',
                        marginTop : this.props.margin ? '10px' : 0,
                        paddingLeft : '10px',
                        paddingRight : '10px',
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        borderBottom : this.props.variant !== 'outlined' ? '1px solid rgba(0,0,0,0.12)' : '',
                        boxShadow : this.props.variant !== 'outlined' ? '1px 2px 12px -9px rgba(0,0,0,0.49)' : '',
                        // backgroundColor : this.isFocussed() ? '#EBF7FF' : '#FFFFFF',
                        backgroundColor : '#FFFFFF',
                        cursor : this.props.cursor
                    }}
                    square
                    variant = {this.props.variant}
                    elevation = {0}
                    onClick = {() => {
                        if (this.props.select_global_field) {
                            this.props.select_global_field(this.props.global_field_data)
                        }
                    }}
                >
                    {this.isMapping() ? <CircularProgress color = 'primary' variant = 'indeterminate' size = {20}/> : <GlobalFieldIcon global_field_display_name = {this.props.global_field_display_name}/>}
                    <div style = {{paddingLeft : '10px', flexGrow : 1}}>
                        {console.log('IRC :: Global Concept', this.props.global_field_data)}
                        <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.global_field_data.global_field}</Typography>
                        {this.renderMappedElement()}
                    </div>
                    {this.renderScore()}
                    {this.renderOptions()}
                </Paper>
                {this.renderMenu()}
                {this.renderRenameDialog()}
                {this.renderDeleteDialog()}
            </ThemeProvider>
        )
    }
}
 
export default withStyles(styles)(GlobalField);